import { Injectable } from '@angular/core';
import { IPreferences, IResponse } from '@interfaces/index';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class PreferenceService {

  constructor(
    private _http_service: HttpService
  ) { }

  getPreferences(): Observable<IResponse<IPreferences[]>> {
    return this._http_service.get('preferences/get-user-preferences')
  }

  savePreferences(preferences: { option_id: number, value: boolean }[]): Observable<IResponse<[]>> {
    return this._http_service.post('preferences/save-user-preferences',
      {
        preferences
      })
  }

}
